import { env } from 'utils/env'

export const isOnMobiDomain = env.HOST?.includes('mobi')
